export default "__VITE_ASSET__CP4MaS2$__"